import { ADD_TO_COMPARE, REMOVE_FROM_COMPARE_LIST } from "../actions/type";
import { toast } from "react-toastify";

// 🧾 Product Interface
export interface CompareProduct {
  id: number | string;
  title?: string;
  price?: number;
  proImg?: string;
  [key: string]: any; // allow flexibility for extra fields
}

// 🧾 State Interface
export interface CompareListState {
  compare_list: CompareProduct[];
}

// 🧾 Action Interface
export interface CompareAction {
  type: string;
  product: CompareProduct;
}

// 🧾 Initial State
const initialState: CompareListState = {
  compare_list: [],
};

// 🧠 Reducer
const compareListReducer = (
  state: CompareListState = initialState,
  action: CompareAction
): CompareListState => {
  switch (action.type) {
    case ADD_TO_COMPARE: {
      const productId = action.product.id;

      // Check if already exists
      const exists = state.compare_list.some(
        (product) => product.id === productId
      );

      if (exists) {
        toast.warn("Already added to Compare List");
        return state;
      }

      toast.success("Added to Compare List");
      return {
        ...state,
        compare_list: [...state.compare_list, action.product],
      };
    }

    case REMOVE_FROM_COMPARE_LIST: {
      const productId = action.product.id;

      const exists = state.compare_list.some(
        (product) => product.id === productId
      );

      if (!exists) {
        toast.error("Item not found in Compare List");
        return state;
      }

      toast.info("Item Removed from Compare List");

      return {
        ...state,
        compare_list: state.compare_list.filter(
          (product) => product.id !== productId
        ),
      };
    }

    default:
      return state;
  }
};

export default compareListReducer;
